module.exports = __webpack_public_path__ + "img/menu 1.ab6ed034.svg";